import React from "react";

import { Navigate, useLocation, useParams } from "react-router-dom";

import useReportShare from "@app/common/access/ShareReport/hooks/useReportShare";
import * as ShareUtils from "@app/common/access/ShareReport/utils";
import useAuth from "@app/common/auth/useAuth";
import ROUTES from "@app/common/routes";
import { withQueryParams } from "@app/common/utils";

import FullPageLoadingSpinnerWithText from "@rui/FullPageLoadingSpinnerWithText";

import MeetingReport from "./MeetingReport";

const MeetingReportAccessControl = () => {
  const { user, hasPreviousSignIn } = useAuth();
  const location = useLocation();
  const { sessionId } = useParams() as { sessionId: string };
  const { accessList, accessListQuery } = useReportShare({
    sessionId,
  });

  if (user) {
    return <MeetingReport />;
  }

  // if no user, wait for access list query to complete,
  // then direct to report if user has access, otherwise
  // to the sign in or sign up page.
  if (accessListQuery.isLoading) {
    return <FullPageLoadingSpinnerWithText delay={1000} />;
  }

  if (
    accessListQuery.isSuccess &&
    Boolean(accessList.currentUserAccessLevel) &&
    !ShareUtils.isForbidden(accessList.currentUserAccessLevel)
  ) {
    return <MeetingReport />;
  }

  const signInOrSignUp = hasPreviousSignIn ? ROUTES.SIGN_IN : ROUTES.SIGN_UP;

  return (
    <Navigate
      to={withQueryParams(signInOrSignUp, { sessionId })}
      state={{
        redirectTo: {
          pathname: ROUTES.meetingReportById(sessionId),
          search: location.search,
        },
      }}
      replace
    />
  );
};

export default MeetingReportAccessControl;
